/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography, Chip } from '@material-ui/core';
import LazyLoad from 'react-lazyload';

// CONSTANTS
import { getLinksByType } from '@/utility/wp';

// UTILITY
import { getLink } from '@/utility/routes';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { CardContainer } from './styles';

function getCategories(categories) {
  const labels = categories.map(category => <Chip label={category.name} key={category.id} />);

  if (categories.length > 1) {
    const catNames = categories.map(item => item.name);
    const title = catNames.join(', ');

    return (
      <Tooltip title={title}>
        <div className="labels-wrapper">{labels}</div>
      </Tooltip>
    );
  }

  return labels;
}

const getTitle = title => {
  return title.length > 45 ? `${title.substring(0, 40)}...` : title;
};

const InsightCard = ({ data, type, hideAuthor, location }) => {
  const links = getLinksByType(type);
  const embeddedCont = data?._embedded || {};

  return (
    <CardContainer className="insight-card">
      <RouterLink to={getLink(links.post, { slug: data.slug })} location={location}>
        <div className="insight-card__image">
          <LazyLoad once>
            <img
              src={
                data.x_featured_media_medium ||
                'https://dummyimage.com/255X180/FFFFFF/000000/?text=No+image'
              }
              alt={data.title?.rendered || 'insight-img'}
            />
          </LazyLoad>
        </div>
        {embeddedCont['wp:term'] && (
          <div className="insight-card__labels">{getCategories(embeddedCont['wp:term'][0])}</div>
        )}
        {data?.title?.rendered && (
          <Typography className="insight-card__title" variant="h5" title={data.title.rendered}>
            {getTitle(data.title.rendered)}
          </Typography>
        )}
      </RouterLink>
      <div className="insight-card__info">
        {embeddedCont.author && !hideAuthor && (
          <Typography className="insight-card__author m-r-10">
            <RouterLink
              className="cut-text"
              to={getLink(links.author, { slug: embeddedCont.author[0].slug })}
              location={location}
            >
              {embeddedCont.author[0].name}
            </RouterLink>
          </Typography>
        )}
        {data?.x_date && <Typography className="insight-card__data">{data.x_date}</Typography>}
      </div>
    </CardContainer>
  );
};

InsightCard.defaultProps = {
  data: {},
  hideAuthor: false,
  location: '',
  type: 'blog',
};

InsightCard.propTypes = {
  data: PropTypes.object,
  type: PropTypes.oneOf(['blog', 'news']),
  hideAuthor: PropTypes.bool,
  location: PropTypes.string,
};

export default React.memo(InsightCard);
